// Tracks Vike client-side page transitions so components (e.g. LoaderBar) can
// mirror React Router's `useNavigation().state`. Updated by the Vike hooks
// `pages/+onPageTransitionStart.ts` and `pages/+onPageTransitionEnd.ts`.

export type NavigationState = "idle" | "loading";

let state: NavigationState = "idle";
const listeners = new Set<() => void>();

export function setNavigationState(next: NavigationState): void {
  if (state === next) return;
  state = next;
  for (const listener of listeners) listener();
}

export function getNavigationState(): NavigationState {
  return state;
}

export function subscribeNavigation(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
